export const idmProductKey = process.env.IDM_KEY
export const fleetoProductKey = process.env.PRODUCT_KEY_FLEETO
export const fleetoV2ProductKey = process.env.PRODUCT_KEY_FLEETOV2
export const fleetoProductURL = process.env.PRODUCT_URL_FLEETO
export const fleetoV2ProductURL = process.env.PRODUCT_URL_FLEETOV2
export const fleetoXLProductURL =
  process.env.PRODUCT_URL_FLEETOXL || 'https://xl.fleeto.id'
export const disableOtp = process.env.DISABLE_OTP
